import { EMPTY_ARRAY } from '~/utils/constants'

export default {
  namespaced: true,
  state: () => ({
    /* Images data */
    images: EMPTY_ARRAY,
    publicIds: EMPTY_ARRAY,
    totalImage: 10,
  }),
  mutations: {
    setData(state, payload) {
      Object.keys(payload).forEach(key => {
        if (state[key] !== undefined) {
          state[key] = payload[key]
        } 
      })
    },
    setImageList(state, payload) {
      const publicIdList = payload.map(element => element.publicId)
      state.publicIds = [...publicIdList]
      state.images = [...payload]
    }
  },
}
